import React from "react";

import "../../views/dashboard/dashboard.css";

type IconType = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export function Trend({ value }: { value?: number | null }) {
  if (value == null)
    return <span className="text-slate-400">No prior-period data</span>;
  const positive = value >= 0;
  return (
    <span className={positive ? "text-emerald-600" : "text-rose-600"}>
      {positive ? "▲" : "▼"} {Math.abs(value).toFixed(1)}% vs last week
    </span>
  );
}

export function KpiCard({
  label,
  value,
  suffix,
  trend,
  hint,
  icon: Icon,
  showTrend = false,
}: {
  label: string;
  value: React.ReactNode;
  suffix?: string;
  trend?: number | null;
  hint?: string | null;
  icon: IconType;
  showTrend?: boolean;
}) {
  const footer = showTrend ? (
    <Trend value={trend} />
  ) : hint ? (
    <span className="text-slate-400">{hint}</span>
  ) : null;

  return (
    <article className="dashboard-card min-h-[142px] p-5">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-slate-700">{label}</p>
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
      </div>
      <p className="mt-3 text-[1.75rem] font-semibold leading-none tracking-tight text-slate-950">
        {value}{" "}
        {suffix ? (
          <span className="text-sm text-slate-500">{suffix}</span>
        ) : null}
      </p>
      {footer ? (
        <p className="mt-4 text-xs font-medium">{footer}</p>
      ) : null}
    </article>
  );
}
